import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { Button } from '../Button';
import * as Styles from './index.styles';
import { openUploadDialog, dropHandler, uploadInputHandler, dragOverHandler } from './index.utils';

const {
    StyledDropeZone,
    StyledUploadButton,
    StyledTopLabel,
    StyledBottomLabel,
    StyledFileName,
    StyledErrorMessage,
    StyledIcon,
    StyledTrashIcon,
    ContainerSvg,
    Svg,
    FileNames,
    FileName,
} = Styles;

export const InputFileUpload = ({
    name,
    disabled,
    onChange,
    onRemove,
    error,
    errorMessage,
    message,
    typeIcon,
    iconImage,
    image,
    radius,
    multiple,
    ...otherProps
}) => {
    const ref = React.useRef(null);
    const [files, setFiles] = React.useState([]);

    const handleNewFile = file => {
        if (file !== undefined) {
            const selectedFiles = files;
            if (multiple) {
                selectedFiles.push(file);
                setFiles([...selectedFiles]);
                return;
            }
            setFiles([file]);
        }
    };

    const commonProps = {
        ref,
        onChange,
        handleNewFile,
    };

    const handleRemoveFile = fileName => {
        const selectedFiles = files;
        const filteredFiles = selectedFiles.filter(file => file.name !== fileName);
        commonProps.ref.current.value = '';
        setFiles([...filteredFiles]);
    };

    React.useEffect(() => {
        window.addEventListener(
            'dragover',
            e => {
                e.preventDefault();
            },
            false,
        );
        window.addEventListener(
            'drop',
            e => {
                e.preventDefault();
            },
            false,
        );
    }, []);

    return (
        <StyledDropeZone
            {...otherProps}
            disabled={disabled}
            onDrop={event => !disabled && dropHandler({ ...commonProps, event })}
            onDragOver={event => !disabled && dragOverHandler(event)}
        >
            {image ||
                (typeIcon ? (
                    <ContainerSvg>
                        <Svg radius={radius}>{iconImage}</Svg>
                    </ContainerSvg>
                ) : (
                    <StyledIcon icon={['far', 'folder-open']} />
                ))}
            <FileNames>
                {!error &&
                    files?.map(file => (
                        <FileName>
                            <StyledFileName>
                                <StyledTrashIcon
                                    icon="trash-can"
                                    size="sm"
                                    onClick={() => {
                                        onRemove(file?.name);
                                        handleRemoveFile(file?.name);
                                    }}
                                />
                                {file?.name}
                            </StyledFileName>
                        </FileName>
                    ))}
            </FileNames>
            <StyledUploadButton error={error} disabled={disabled}>
                <input
                    name={name}
                    ref={ref}
                    disabled={disabled}
                    hidden
                    type="file"
                    onChange={event => !disabled && uploadInputHandler({ ...commonProps, event })}
                />
                {!disabled && <StyledTopLabel>Arraste um arquivo aqui ou</StyledTopLabel>}
                <Button
                    disabled={disabled}
                    primary
                    type="button"
                    fullWidth
                    onClick={() => openUploadDialog(commonProps)}
                >
                    <Icon icon="cloud-arrow-up" size="xs" />
                    CLIQUE PARA SELECIONAR
                </Button>
                {message && <StyledBottomLabel>{message}</StyledBottomLabel>}
                {error && !disabled && <StyledErrorMessage> {errorMessage}</StyledErrorMessage>}
            </StyledUploadButton>
        </StyledDropeZone>
    );
};

InputFileUpload.propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func,
    onRemove: PropTypes.func,
    width: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    message: PropTypes.string,
    typeIcon: PropTypes.bool,
    image: PropTypes.string,
    iconImage: PropTypes.string,
    radius: PropTypes.string,
    multiple: PropTypes.bool,
};

InputFileUpload.defaultProps = {
    name: '',
    onChange: () => undefined,
    onRemove: () => undefined,
    width: '712px',
    disabled: false,
    error: false,
    errorMessage: '',
    message: '',
    typeIcon: '',
    image: '',
    iconImage: '',
    radius: '',
    multiple: false,
};

InputFileUpload.Styles = Styles;
